import { render, staticRenderFns } from "./attachment-item.vue?vue&type=template&id=1e366368&scoped=true"
import script from "./attachment-item.vue?vue&type=script&lang=js"
export * from "./attachment-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e366368",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e366368')) {
      api.createRecord('1e366368', component.options)
    } else {
      api.reload('1e366368', component.options)
    }
    module.hot.accept("./attachment-item.vue?vue&type=template&id=1e366368&scoped=true", function () {
      api.rerender('1e366368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/attachment/attachment-item.vue"
export default component.exports